export default {
    marcas: [],
    marca: {}
}